import React, { Component, Fragment } from 'react'
import { Layout } from 'app/common/layout'
import { FormattedMessage, injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { media, ResponsiveContainer, style } from 'app/assets/styles'
import { Breadcrumb } from 'app/common/breadcrumb'
import { ErrorManagement } from 'app/common/error-management'
import styled from 'styled-components'
import { toSrcSet } from 'shared/utils'
import { Picture } from 'react-responsive-picture'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme'
import { COLOR } from 'app-v2/design-tokens'
import { H2, H4, H5, styleH2, styleText } from 'app/common/typography'
import { CircleChevron, CircleMap } from 'app/assets/icons'
import type { BirthdayFormData, BirthdayItem } from 'shared/types'
import CarouselElement from 'nuka-carousel'
import { BookPush } from './BookPush'
import header_kingsbirthday from 'app/assets/images/kings-birthday/header.jpg'
import header_kingsbirthday_2x from 'app/assets/images/kings-birthday/header@2x.jpg'
import header_kingsbirthday_3x from 'app/assets/images/kings-birthday/header@3x.jpg'
import hero from 'app/assets/images/kings-birthday/hero.png'
import hero_2x from 'app/assets/images/kings-birthday/hero@2x.png'
import hero_3x from 'app/assets/images/kings-birthday/hero@3x.png'
import baloon from 'app/assets/images/kings-birthday/baloon.png'
import baloon_2x from 'app/assets/images/kings-birthday/baloon@2x.png'
import baloon_3x from 'app/assets/images/kings-birthday/baloon@3x.png'
import confettis from 'app/assets/images/kings-birthday/confettis.png'
import confettis_2x from 'app/assets/images/kings-birthday/confettis@2x.png'
import confettis_3x from 'app/assets/images/kings-birthday/confettis@3x.png'
import donut from 'app/assets/images/kings-birthday/donut.png'
import donut_2x from 'app/assets/images/kings-birthday/donut@2x.png'
import donut_3x from 'app/assets/images/kings-birthday/donut@3x.png'
import queen from 'app/assets/images/kings-birthday/queen.png'
import queen_2x from 'app/assets/images/kings-birthday/queen@2x.png'
import queen_3x from 'app/assets/images/kings-birthday/queen@3x.png'
import gift from 'app/assets/images/kings-birthday/gift.png'
import gift_2x from 'app/assets/images/kings-birthday/gift@2x.png'
import gift_3x from 'app/assets/images/kings-birthday/gift@3x.png'
import pirate from 'app/assets/images/kings-birthday/pirate.png'
import pirate_2x from 'app/assets/images/kings-birthday/pirate@2x.png'
import pirate_3x from 'app/assets/images/kings-birthday/pirate@3x.png'
import map from 'app/assets/images/kings-birthday/map.jpg'
import map_2x from 'app/assets/images/kings-birthday/map@2x.jpg'
import map_3x from 'app/assets/images/kings-birthday/map@3x.jpg'
import { InputAddressAutocomplete } from 'app/store-locator/input-address-autocomplete'

const { red, red3, yellow, blue3, tertiary } = oldColors

type Props = {
    fetchPageData: () => void,
    formData: BirthdayFormData,
    error: ?any,
    networkError: any,
    intl: IntlShape,
    error: any
}

type State = {
    slideIndex: number
}

class _KingsBirthdayComponent extends Component<Props, State> {
    state = {
        slideIndex: 0
    }

    componentDidMount() {
        this.props.fetchPageData()
    }

    render() {
        const { slideIndex } = this.state
        const { intl, formData, error, networkError } = this.props
        if (error || networkError) {
            return <ErrorManagement error={error} networkError={networkError} />
        }
        if (formData) {
            return (
                <Layout background="plain">
                    <Banner
                        sources={[
                            {
                                srcSet: toSrcSet([
                                    header_kingsbirthday,
                                    header_kingsbirthday_2x,
                                    header_kingsbirthday_3x
                                ])
                            }
                        ]}
                    />
                    <BreadcrumbContainer>
                        <Breadcrumb
                            breadcrumbArray={[
                                {
                                    title: intl.formatMessage({
                                        id: 'king.birthday.breadcrumb.end'
                                    })
                                }
                            ]}
                        />
                    </BreadcrumbContainer>
                    <Hero>
                        <Title>
                            <FormattedMessage id="king.birthday.title.start">
                                {(text: string) => <H2 color={red3}>{text}</H2>}
                            </FormattedMessage>
                            <FormattedMessage id="king.birthday.title.middle">
                                {(text: string) => (
                                    <StyledH2 color={yellow}>{text}</StyledH2>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="king.birthday.title.end">
                                {(text: string) => (
                                    <StyledH2 color={red3}>{text}</StyledH2>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="king.birthday.description.start">
                                {(text: string) => (
                                    <Description>{text}</Description>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="king.birthday.description.end">
                                {(text: string) => (
                                    <Description>{text}</Description>
                                )}
                            </FormattedMessage>
                        </Title>
                        <MainCaracter
                            sources={[
                                {
                                    srcSet: toSrcSet([hero, hero_2x, hero_3x])
                                }
                            ]}
                        />
                        <Baloon
                            sources={[
                                {
                                    srcSet: toSrcSet([
                                        baloon,
                                        baloon_2x,
                                        baloon_3x
                                    ])
                                }
                            ]}
                        />
                        <Confettis
                            sources={[
                                {
                                    srcSet: toSrcSet([
                                        confettis,
                                        confettis_2x,
                                        confettis_3x
                                    ])
                                }
                            ]}
                        />
                        <Donut
                            sources={[
                                {
                                    srcSet: toSrcSet([
                                        donut,
                                        donut_2x,
                                        donut_3x
                                    ])
                                }
                            ]}
                        />
                    </Hero>
                    <BookPush />
                    <Explanation>
                        <ResponsiveContainer>
                            <FormattedMessage id="king.birthday.explanation.title.start">
                                {(text: string) => (
                                    <StyledH2 color={yellow}>{text}</StyledH2>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="king.birthday.explanation.title.end">
                                {(text: string) => (
                                    <StyledH2 color={red3}>{text}</StyledH2>
                                )}
                            </FormattedMessage>
                            <FormattedMessage id="king.birthday.explanation.description">
                                {(text: string) => (
                                    <Description>{text}</Description>
                                )}
                            </FormattedMessage>
                            <Step background={colors.crunchyGreen}>
                                <FormattedMessage id="king.birthday.explanation.step1">
                                    {(text: string) => (
                                        <H5 color="white">{text}</H5>
                                    )}
                                </FormattedMessage>
                            </Step>
                            <Step background={yellow}>
                                <FormattedMessage id="king.birthday.explanation.step2">
                                    {(text: string) => (
                                        <H5 color="white">{text}</H5>
                                    )}
                                </FormattedMessage>
                                <Carousel
                                    cellAlign="center"
                                    slideIndex={slideIndex}
                                    afterSlide={slideIndex =>
                                        this.setState({ slideIndex })
                                    }
                                    cellSpacing={10}
                                    wrapAround
                                    renderCenterLeftControls={({
                                        previousSlide
                                    }) => (
                                        <ChevronContainer
                                            onClick={previousSlide}>
                                            <CircleChevron
                                                direction="left"
                                                background="white"
                                                color={COLOR.PRIMARY}
                                            />
                                        </ChevronContainer>
                                    )}
                                    renderCenterRightControls={({
                                        nextSlide
                                    }) => (
                                        <ChevronContainer onClick={nextSlide}>
                                            <CircleChevron
                                                background="white"
                                                color={COLOR.PRIMARY}
                                            />
                                        </ChevronContainer>
                                    )}>
                                    {formData.gifts.map((g: BirthdayItem) => (
                                        <Fragment>
                                            {g.image && (
                                                <Reward
                                                    sources={[
                                                        {
                                                            srcSet: toSrcSet(
                                                                g.image
                                                            )
                                                        }
                                                    ]}
                                                />
                                            )}
                                        </Fragment>
                                    ))}
                                </Carousel>
                            </Step>
                            <Step background={blue3}>
                                <FormattedMessage id="king.birthday.explanation.step3.one">
                                    {(text: string) => (
                                        <H5 color="white">{text}</H5>
                                    )}
                                </FormattedMessage>
                                <FormattedMessage id="king.birthday.explanation.step3.two">
                                    {(text: string) => (
                                        <H5 color="white">{text}</H5>
                                    )}
                                </FormattedMessage>
                                <FormattedMessage id="king.birthday.explanation.step3.three">
                                    {(text: string) => (
                                        <H5 color="white">{text}</H5>
                                    )}
                                </FormattedMessage>
                                <FormattedMessage id="king.birthday.explanation.step3.cta">
                                    {(text: string) => (
                                        <ProgrammLink
                                            href="kings_birthday.pdf"
                                            background={red3}
                                            color="white"
                                            download="kings_birthday">
                                            {text}
                                        </ProgrammLink>
                                    )}
                                </FormattedMessage>
                            </Step>
                            <Queen
                                sources={[
                                    {
                                        srcSet: toSrcSet([
                                            queen,
                                            queen_2x,
                                            queen_3x
                                        ])
                                    }
                                ]}
                            />
                            <Gift
                                sources={[
                                    {
                                        srcSet: toSrcSet([
                                            gift,
                                            gift_2x,
                                            gift_3x
                                        ])
                                    }
                                ]}
                            />
                            <Pirate
                                sources={[
                                    {
                                        srcSet: toSrcSet([
                                            pirate,
                                            pirate_2x,
                                            pirate_3x
                                        ])
                                    }
                                ]}
                            />
                        </ResponsiveContainer>
                    </Explanation>
                    <BookPush />
                    <StorelocatorPushContainer>
                        <StorelocatorPush>
                            <Block>
                                <CircleMap color="white" size={40} />
                                <FormattedMessage id="storelocator.title.landing">
                                    {(text: string) => (
                                        <H4 center color="white">
                                            {text}
                                        </H4>
                                    )}
                                </FormattedMessage>
                                <AddressSearchContainer>
                                    <InputAddressAutocomplete
                                        forKingsBirthday
                                        filters={['BIRTHDAY']}
                                    />
                                </AddressSearchContainer>
                            </Block>
                            <ImageMapContainer>
                                <ImageMap
                                    sources={[
                                        {
                                            srcSet: toSrcSet([
                                                map,
                                                map_2x,
                                                map_3x
                                            ])
                                        }
                                    ]}
                                />
                            </ImageMapContainer>
                        </StorelocatorPush>
                    </StorelocatorPushContainer>
                </Layout>
            )
        }
        return null
    }
}

const Banner = styled(Picture)`
    margin-top: 90px;
    width: 100%;
    font-size: 0;
`

const BreadcrumbContainer = styled.div`
    position: absolute;
    z-index: 2;
    left: 40px;
    top: 120px;
    ${media.large`
        left: calc((100% - 1280px) / 2);
    `};
`

const Hero = styled.div`
    position: relative;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 50px;
    ${media.medium`
        margin: 0;
        min-height: 400px;
    `};
`

const Title = styled.div`
    margin-left: 20px;
    margin-right: 20px;
    ${media.medium`
        margin: auto;
        position: absolute;
        z-index: 2;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    `};
`

const StyledH2 = styled.span`
    ${styleH2};
`

const Description = styled.p`
    ${styleText};
    text-align: center;
    margin: 20px auto 0 auto;
    ${media.medium`
        max-width: 700px;
    `};
`

const MainCaracter = styled(Picture)`
    display: none;
    ${media.medium`
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        img {
            font-size: 0;
        }
    `};
    ${media.large`
        left: calc((100% - 1280px) / 2);
    `};
    font-size: 0;
`

const Baloon = styled(MainCaracter)`
    ${media.medium`
        top: 30px;
        left: 200px;
    `};
    ${media.large`
        left: calc((100% - 1280px) / 2 + 250px);
    `};
`

const Confettis = styled(Baloon)`
    ${media.medium`
        top: 70px;
        right: 200px;
        left: unset;
        bottom: 0;
    `};
    ${media.large`
        right: calc((100% - 1280px) / 2 + 200px);
    `};
`

const Donut = styled(Confettis)`
    ${media.medium`
        right: 10px;
        bottom: 20px;
        top: unset;
        left: unset;
    `};
    ${media.large`
        right: calc((100% - 1280px) / 2);
    `};
`

const Reward = styled(Picture)`
    font-size: 0;
    width: 150px;
    ${media.medium`
        width: 300px;
    `};
`

const Explanation = styled.div`
    background-color: ${tertiary};
    padding: 20px 0;
    text-align: center;
    position: relative;
    ${media.medium`
        padding: 50px auto;
    `};
`

const Step = styled.div`
    background-color: ${props => props.background};
    padding: 15px;
    margin: 20px auto;
    border-radius: 20px;
    max-width: 500px;
    ${media.medium`
        padding: 30px 100px;
        margin: 70px auto;
    `};
`

const Queen = styled(Picture)`
    display: none;
    ${media.medium`
        display: block;
        position: absolute;
        top: 75px;
        right: calc((100% - 850px) / 2);
    `};
`

const Gift = styled(Queen)`
    ${media.medium`
        top: 40%;
    `};
`

const Pirate = styled(Gift)`
    ${media.medium`
        top: unset;
        bottom: 100px;
    `};
`

const StorelocatorPushContainer = styled.div`
    margin: 30px 20px;
    ${media.medium`
        margin-top: 50px;
        margin-bottom: 50px;
    `};
`

const StorelocatorPush = styled.div`
    border-radius: 20px;
    display: flex;
    justify-content: center;
    margin: auto;
    max-width: 500px;
    ${media.medium`
        max-width: 900px;
        top: 200px;
        margin-left: auto;
        margin-right: auto;
    `};
`

const ImageMapContainer = styled.div`
    width: 50%;
    font-size: 0;
    display: none;
    ${media.medium`
        display: block;
    `};
`

const ImageMap = styled(Picture)`
    width: 100%;
`

const Block = styled.div`
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    background-color: ${red3};
    border-radius: 20px;
    width: 100%;
    min-height: 150px;
    ${media.medium`
        border-radius: 20px 0 0 20px;
        width: 50%;
        min-height: unset;
    `};
`

const AddressSearchContainer = styled.div`
    width: 100%;
    ${media.medium`
        width: 70%;
    `};
`

const Carousel = styled(CarouselElement)`
    padding-bottom: 80px;
    margin-top: 20px;
    .slider-control-bottomcenter {
        width: 100%;
    }
    ${props => `
        .slider-control-bottomcenter li:nth-child(${props.slideIndex +
            1}) button {
            color: ${red} !important;
        }`};
`

const ChevronContainer = styled.div`
    cursor: pointer;
`

const ProgrammLink = styled.a`
    ${style.buttonMedium};
    border: none;
    margin-top: 20px;
`

export const KingsBirthdayComponent = injectIntl(_KingsBirthdayComponent)
